<template>
  <div class="playlet">
    <!-- <el-card class="box-card">
      <div class="selectionArea">
        <div class="item">
          <span class="title">视频名称</span>
          <el-input v-model.trim="parameter.name" clearable placeholder="请输入博主/视频标题" />
        </div>

        <div class="item">
          <span class="title">别名</span>
          <el-input v-model="parameter.alias_name" clearable placeholder="请输入" />
        </div>
        <div class="item">
          <span class="title">视频平台</span>
          <el-select v-model="parameter.type" clearable placeholder="请选择" :style="{ width: '100%' }">
            <el-option
              v-for="item in states"
              :key="item.id"
              :label="item.value"
              :value="item.id"
            />
          </el-select>
        </div>
        <div class="item">
          <el-button size="mini" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
          <el-button size="mini" type="info" icon="el-icon-refresh" @click="reset">重置</el-button>
        </div>
      </div>

    </el-card> -->

    <el-card>
      <el-button
        size="mini"
        type="success"
        icon="el-icon-s-help"
        style="float: right;margin-bottom:10px"
        @click="add"
      >创建</el-button>
      <!-- 主体区 -->
      <div>
        <el-table
          v-loading="loading"
          :data="tableData"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="key"
            label="抖音号"
            width="300"
            align="center"
          />
          <el-table-column
            prop="cookie"
            label="cookie名称"
            width="2000"
            align="center"
          >
            <template slot-scope="scope">
              <div style=" overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                {{ scope.row.value }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
            fixed="right"
          >
            <template scope="scope">
              <!-- <el-button type="primary" size="small" @click="editrow(scope.row)">修改</el-button> -->
              <!-- <el-button type="warning" size="small" @click="look(scope.row.id)">预览</el-button>
              <el-button type="primary" size="small" @click="bandtakenotes(scope.row)">绑定记录</el-button> -->
              <el-button
                type="danger"
                size="small"
                @click="myDelete(scope.row.key)"
              >删除</el-button>
            </template>
          </el-table-column></el-table>
      </div>
      <pagination-right
        :total="total"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
      <!-- <el-dialog
        :title="check ? '编辑广告配置' : '创建广告配置'"
        :visible.sync="dialogVisible"
        width="800px"
        :before-close="handleClose"
        :destroy-on-close="true"
        :close-on-click-modal="false"
        :append-to-body="true"
        @close="1"
      >
        <detailList ref="add" @determine="determine" />
      </el-dialog> -->
    </el-card>
    <!-- <el-dialog
      title="预览"
      :visible.sync="priwdialogVisible"
      :modal-append-to-body="false"
      :append-to-body="true"
      width="340px"
    >
      <cookiecreatedialog ref="timepreview" />
    </el-dialog> -->
    <el-dialog
      title="新增"
      :visible.sync="cookiedialogVisible"
      :modal-append-to-body="false"
      :append-to-body="true"
      :destroy-on-close="true"
      width="900px"
    >
      <cookiecreatedialog
        ref="cookiecreatedialogview"
        @updata="updatar"
      />
    </el-dialog>
  </div>
</template>

<script>
import cookiecreatedialog from './components/cookiecreatedialog.vue'
import PaginationRight from '@/components/PaginationRight/index.vue'
// import detailList from './components/detailList.vue'
import { operateCookie, videoSettingDetail, videoAdSettinAdd, videoAdSettingUpdate, operateCookiedelete } from '@/api/sourceMaterial.js'
export default {
  name: 'Playlet',
  components: {
    PaginationRight,
    // detailList,
    cookiecreatedialog
  },
  data() {
    return {
      parameter: {
        page: 1,
        page_size: 10,
        name: null,
        alias_name: null,
        type: null
      },
      loading: false,
      states: [
        { id: 1, value: '抖音' },
        { id: 2, value: '快手' }
      ],

      tableData: [],
      total: 10,
      dialogVisible: false,
      check: undefined,
      priwdialogVisible: false,
      dialogVisiblenotes: false,
      cookiedialogVisible: false
    }
  },

  created() {
    this.getDatas()
  },
  mounted() {},
  methods: {
    updata() {
      this.dialogVisiblenotes = false
    },
    bandtakenotes(row) {
      this.dialogVisiblenotes = true
      this.$nextTick(() => {
        this.$refs.bandstaffnotesview.send(row)
      })
    },
    async look(id) {
      const data = await videoSettingDetail({
        id
      })
      console.log('data', data.data)
      this.priwdialogVisible = true
      setTimeout(() => {
        // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.timepreview.send(data.data)
      }, 100)
    },

    add() {
      this.cookiedialogVisible = true
      // this.$nextTick(() => {
      //   this.$refs.add.reset()
      // })
    },
    editrow(row) {
      this.check = row
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.add.sendr(row)
      })
    },

    handleClickStop() {
      this.$nextTick(() => {
        const domImageView = document.querySelector('.el-image-viewer__mask') // 获取遮罩层dom
        if (!domImageView) {
          return
        }
        domImageView.addEventListener('click', () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector('.el-image-viewer__close').click()
        })
      })
    },
    async getDatas() {
      // this.loading = true
      const data = await operateCookie(this.parameter)
      // const newArray = data.data.list.map(num => ({ cookie: num }))
      this.tableData = data.data.list
      this.total = data.data.total
      console.log('this.tableData', this.tableData)
      // this.loading = false
    },
    fetchPageSize(e) {
      this.parameter.page_size = e
      this.getDatas()
    },

    fetchCurrentPage(e) {
      this.parameter.page = e
      this.getDatas()
    },

    handleClose() {
      this.check = undefined
      this.dialogVisible = false
    },

    // 删除
    myDelete(key) {
      console.log(key)
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          operateCookiedelete({
            cookie_key: key
          }).then(res => {
            this.getDatas()
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 提交
    async determine(obj) {
      console.log('obj:', obj)
      try {
        obj.id ? await videoAdSettingUpdate(obj) : await videoAdSettinAdd(obj)
        this.$message({
          message: obj.id ? '修改成功' : '创建成功',
          type: 'success'
        })
        this.dialogVisible = false
        this.$refs.add.reset()
        this.getDatas()
      } catch (error) {
        this.$refs.add.sendr(obj)
      }
    },
    // 搜索
    search() {
      this.parameter.page = 1
      this.getDatas()
    },

    // 重置
    reset() {
      this.parameter = {
        name: null,
        alias_name: null,
        type: null,
        page: 1,
        page_size: 10
      }
      this.getDatas()
    },
    close() {
      this.getDatas()
    },
    updatar() {
      this.cookiedialogVisible = false
      this.getDatas()
    }
  }
}
</script>

<style scoped>
.playlet {
  margin: 30px;
  width: 95%;
  margin: 0 auto;
}
.el-card {
  margin-top: 20px;
}
.selectionArea {
  display: flex;
  flex-wrap: wrap;
}

.item {
  display: flex;
  align-items: center;
  flex-basis: calc(25% - 10px);
  margin-right: 10px;
  margin-bottom: 10px;
}

.title {
  white-space: pre;
  display: inline-block;
  margin-right: 7px;
}

.button-group {
  flex-basis: 100%; /* 按钮组占据一整行宽度 */
}
.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.box-card {
  height: 70px;
}
</style>

